export default __webpack_public_path__ + "static/media/cleaner.fc30b909.jpg";